export const Features = {
  BILLING_PAYMENT: 'BillingAndPayment',
  ATTENDANCE: 'Attendance',
  ACADEMICS: 'Academics',
  ACCOUNTING: 'Accounting',
  PAYROLL: 'Payroll',
  COMMUNICATION: 'Communication',
  LMS: 'Lms',
  BEHAVIORS: 'Behavior',
  STDASSESSMENT: 'std-assessment',
  COMPUTER_ASSESSMENT: 'computer-assessment',
  SALES_AND_SUBSCRIPTIONS: 'SalesAndSubscriptions',
} as const;

export const Roles = {
  PARTNER_ADMIN: 'partner_admin',
  ATTENDANCE_MANAGER: 'attendance-manager',
  STAFF_ATTENDANCE_MANAGER: 'staff-attendance-manager',
  SCHOOL_ADMIN: 'school_admin',
  EXAM_MANAGER: 'manage-exams',
  MARK_ENTRY: 'marks-entry',
  STAFF_MANAGER: 'staff-manager',
  SCHOOL_STAFF: 'school_staff',
  STUDENT_MANAGER: 'student-manager',
  BILLING: 'billing',
  FEES_COLLECTION: 'fees_collection',
  STUDENT: 'student',
  PARENT: 'parent',
  TEACHER: 'teacher',
  VIEW_FINANCIAL_REPORTS: 'view-financial-reports',
  MANAGE_EXPENSES: 'manage-expenses',
  EXPENSE_APPROVER: 'expense-approver',
  SEND_MESSAGE: 'send-message',
  MANAGE_PAYROLL: 'manage-payroll',
  MANAGE_INCOMES: 'manage-incomes',
  SALES_MANAGER: 'sales-manager',
  BEHAVIOR_MANAGER: 'behavior-manager',
  SYSTEM_ADMIN: 'system-admin',
  ACADEMICS_MANAGER: 'academics-manager',
} as const;

export const ALL_ROLES = Object.values(Roles);

export const SUBSCRIPTION_FREQUENCIES = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
] as const;

export const AssessmentStatus = {
  DRAFT: 'DRAFT',
  GENERATING: 'GENERATING',
  REVIEW: 'REVIEW',
  READY: 'READY',
  PUBLISHED: 'PUBLISHED',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
} as const;

export const AssessmentPurpose = {
  PRACTICE: 'PRACTICE',
  GRADED: 'GRADED',
} as const;

export const QuestionType = {
  MCQ: 'MCQ',
  TF: 'TF',
  SA: 'SA',
  ESSAY: 'ESSAY',
  FIB: 'FIB',
} as const;

export const DifficultyLevel = {
  REMEMBER: 'REMEMBER',
  UNDERSTAND: 'UNDERSTAND',
  APPLY: 'APPLY',
  ANALYZE: 'ANALYZE',
  EVALUATE: 'EVALUATE',
  CREATE: 'CREATE',
} as const;

export const SubmissionStatus = {
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
  GRADING: 'GRADING',
  GRADED: 'GRADED',
  VOIDED: 'VOIDED',
} as const;

export const STAGED_PAYMENT_CATEGORIES = {
  SUBSCRIPTION: 'subscription',
  FEES: 'fees',
} as const;

export const STAGED_PAYMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ALL: 'ALL',
} as const;

export const ACADEMIC_HEALTH_THRESHOLDS = {
  EXCELING: 85,
  ON_TRACK: 65,
  NEEDS_SUPPORT: 50,
  MISSING_CRITICAL: 3,
} as const;

export const BEHAVIOR_HEALTH_THRESHOLDS = {
  EXEMPLARY: 5,
  NEEDS_ATTENTION: -5,
} as const;
